import { useEffect, useState } from "react";

export default function InputFile({className, name, required, accept, disabled, onChange, value, inputRef}){
    const [inputFile, setInputFile] = useState(null);
    const fileName = inputFile && inputFile.name;
    
    function onInputFile(e) {
        const file = e.target.files[0];
		setInputFile(file);
		if(onChange) onChange(e);
	}

    useEffect(()=>{
        setInputFile((value && value instanceof File)? value : null);
    }, [value])

    return (
        <div className="flex items-end flex-wrap">
            <div className={`form-input p-0 relative inline-block mb-2 ${className || ''}`}>
                <input
                    id={name}
                    name={name}
                    className="absolute inset-0 hidden"
                    disabled={disabled}
                    required={required}
                    type="file"
                    onChange={e=>onInputFile(e)}
                    accept={accept} //"image/png, image/jpeg", ".jpg"
                    ref={inputRef}
                />
                <label htmlFor={name} className="btn block flex-grow form-input border-0 w-full" disabled={disabled}>{inputFile?"Change File":"Choose File"}</label>
            </div>
            <p className="inline-block p-4">{fileName || (inputFile && "No File Name") || (!inputFile && "No File Selected")}</p>
        </div>
    )
}